import type { Step } from "react-joyride";

export const categoriesTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການຫມວດຫມູ່ຟອມ! ຫມວດຫມູ່ຟອມຊ່ວຍທ່ານຈັດກຸ່ມຟອມຕາມປະເພດ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="categories-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງຫມວດຫມູ່ໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງຫມວດຫມູ່ຟອມທີ່ທ່ານຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="categories-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາຫມວດຫມູ່ຕາມຊື່ ຫຼື ປ່ຽນລະບົບການສະແດງຜົນ (Grid ຫຼື List).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="categories-content"]',
    content:
      "ນີ້ແມ່ນພາກສະແດງຫມວດຫມູ່ຟອມ. ທ່ານສາມາດເບິ່ງຫມວດຫມູ່ທັງໝົດ, ແກ້ໄຂ, ປິດ/ເປີດການໃຊ້ງານ, ຫຼືລຶບຫມວດຫມູ່. ທ່ານຍັງສາມາດເບິ່ງຈຳນວນຟອມທີ່ໃຊ້ງານໃນແຕ່ລະຫມວດຫມູ່.",
    placement: "top",
  },
];
